import React from "react";
function CustomerLogout(){
    localStorage.clear();
    window.location.href='/customer/login'
}

export default CustomerLogout;